import { render, staticRenderFns } from "./chart_js_base.vue?vue&type=template&id=8dd88a1e&scoped=true&"
import script from "./chart_js_base.vue?vue&type=script&lang=js&"
export * from "./chart_js_base.vue?vue&type=script&lang=js&"
import style0 from "./chart_js_base.vue?vue&type=style&index=0&id=8dd88a1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd88a1e",
  null
  
)

export default component.exports